module.exports = __webpack_public_path__ + "img/facebook.12473248.svg";